import { RestService } from "@abp/ng.core";
import { CurrencyPipe } from "@angular/common";
import { Injectable } from "@angular/core";
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as moment from "moment";
import { isUndefined } from "util";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
// import { ActionNotificationComponent } from "../views/partials/content/crud/action-notification/action-notification.component";



export enum MessageType {
	Create,
	Read,
	Update,
	Delete
}

@Injectable()
export class LayoutUtilsService {

    constructor(
		private snackBar: MatSnackBar,
		private dialog: MatDialog, 
		private currencyPipe: CurrencyPipe,
		private restService: RestService
    ) {}

	getBootstrapClass(inputWidth?: number) {
		var width = window.innerWidth;
		if (inputWidth != undefined) {
			width = inputWidth
		}

		if (width < 576) {
			return 0; // Extra small
		} else if (width < 768) {
			return 1; // Small
		} else if (width < 992) {
			return 2; // Medium
		} else if (width < 1200) {
			return 3; // Large
		}

		return 4;
	}

	
	/** QWERT **
	 * Create string for paging, sorting and filtering to be used in services.
	 *
	 * @param pageNumber: number
	 * @param pageSize: number
	 * @param sortField: string
	 * @param sortDirection: string
	 * @param filter: string
	 */

	// variables to be used to create the string



	// string to be returned



	getPagedSortedFilteredString(pageNumber?: number,
		pageSize?: number,
		sortField: string = '',
		sortDirection: string = '',
		filter?: string) {
	
			let gString = '';

		let checkPageNumber = false;
		let checkPageSize = false;
		let checkSortField = false;
		let checkSortDirection = false;
		let checkFilter = false;

		let pnText = 'SkipCount=';
		let psText = 'MaxResultCount=';
		let sfText = 'Sorting=';
		let sdText = 'asc';
		let fText = 'Filter=';


		if (pageNumber != null && pageNumber > 0) {
			gString = '?' + pnText + (pageNumber - 1) * pageSize;
			checkPageNumber = true;
		}

		if (pageSize != null && pageSize > 0) {
			if (checkPageNumber) {
				gString += '&' + psText + pageSize;
			} else {
				gString = '?' + psText + pageSize;
			}
			checkPageSize = true;
		}

		if (checkPageNumber || checkPageSize) {
			gString += '&' + sfText + sortField + '%20' + sortDirection;
		} else {
			gString = '?' + sfText + sortField + '%20' + sortDirection;
		}

		if (!isUndefined(filter) && filter.length > 0) {
			gString += '&' + fText + filter;
		}

		return gString;
	}


	getPagedSortedString(pageNumber?: number,
		pageSize?: number,
		sortField: string = '',
		sortDirection: string = '') {
	
		let gString = '';

		let checkPageNumber = false;
		let checkPageSize = false;
		let checkSortField = false;
		let checkSortDirection = false;

		let pnText = 'SkipCount=';
		let psText = 'MaxResultCount=';
		let sfText = 'Sorting=';
		let sdText = 'asc';


		if (pageNumber != null && pageNumber > 0) {
			gString = '?' + pnText + (pageNumber - 1) * pageSize;
			checkPageNumber = true;
		}

		if (pageSize != null && pageSize > 0) {
			if (checkPageNumber) {
				gString += '&' + psText + pageSize;
			} else {
				gString = '?' + psText + pageSize;
			}
			checkPageSize = true;
		}

		if (checkPageNumber || checkPageSize) {
			gString += '&' + sfText + sortField + '%20' + sortDirection;
		} else {
			gString = '?' + sfText + sortField + '%20' + sortDirection;
		}

		return gString;
	}


    getPagedSortedFilteredStringPrimeNG(
		skipCount?: number,
		pageSize?: number,
		sortField: string = '',
		sortDirection: string = '',
		filter?: string) {
		let gString = '';

		let checkPageNumber = false;
		let checkPageSize = false;
		let checkSortField = false;
		let checkSortDirection = false;
		let checkFilter = false;

		let pnText = 'SkipCount=';
		let psText = 'MaxResultCount=';
		let sfText = 'Sorting=';
		let sdText = 'asc';
		let fText = 'Filter=';


		if (skipCount != null && skipCount > 0) {
		gString = '?' + pnText + (skipCount);
		checkPageNumber = true;
		}

		if (pageSize != null && pageSize > 0) {
		if (checkPageNumber) {
		gString += '&' + psText + pageSize;
		} else {
		gString = '?' + psText + pageSize;
		}
		checkPageSize = true;
		}

		if (checkPageNumber || checkPageSize) {
		gString += '&' + sfText + sortField + '%20' + sortDirection;
		} else {
		gString = '?' + sfText + sortField + '%20' + sortDirection;
		}

		if (!isUndefined(filter) && filter.length > 0) {
		gString += '&' + fText + filter;
		}

		return gString;
	}

	getPagedSortedStringPrimeNG(
		skipCount?: number,
		pageSize?: number,
		sortField: string = '',
		sortDirection: string = '') {
		let gString = '';

		let checkPageNumber = false;
		let checkPageSize = false;
		let checkSortField = false;
		let checkSortDirection = false;
		let checkFilter = false;

		let pnText = 'SkipCount=';
		let psText = 'MaxResultCount=';
		let sfText = 'Sorting=';
		let sdText = 'asc';
		let fText = 'Filter=';


		if (skipCount != null && skipCount > 0) {
		gString = '?' + pnText + (skipCount);
		checkPageNumber = true;
		}

		if (pageSize != null && pageSize > 0) {
		if (checkPageNumber) {
		gString += '&' + psText + pageSize;
		} else {
		gString = '?' + psText + pageSize;
		}
		checkPageSize = true;
		}

		if (checkPageNumber || checkPageSize) {
		gString += '&' + sfText + sortField + '%20' + sortDirection;
		} else {
		gString = '?' + sfText + sortField + '%20' + sortDirection;
		}

		return gString;
	}

	getLocaleDateObj(datetime : Date) : Date
	{
		return moment.utc(datetime).local().toDate();
	}

	// format local date
	getLocaleDate(datetime: Date) {
		var ret = "";

		if (datetime != null) {
			ret = moment.utc(datetime).local().format('DD.MM.YYYY');
		}
		return ret;
	}

	// format local date/time
	getLocaleDateTime(datetime: Date) {
		var ret = "";

		if (datetime != null) {
			ret = moment.utc(datetime).local().format();
			// ret = moment.utc(datetime).local().format('YYYY-MM-DDThh:mm:ss');
			// ret = moment.utc(datetime).local().format('DD.MM.YYYY, hh:mm');
		}
		return ret;
	}

	getLocaleDateTimeDE(datetime: Date) {
		var ret = "";

		if (datetime != null) {
			// ret = moment.utc(datetime).local().format('YYYY-MM-DDThh:mm:ss');
			ret = moment.utc(datetime).local().format('DD.MM.YYYY, HH:mm');
		}
		return ret;
	}

	getCurrencyFormat(amount: number, isocode: string) {
        return this.currencyPipe.transform(amount, isocode);
    }

	getRandomColor() {
		var color = Math.floor(0x1000000 * Math.random()).toString(16);
		return '#' + ('000000' + color).slice(-6);
	}

	getRandomColor2() {
		var length = 6;
		var chars = '0123456789ABCDEF';
		var hex = '#';
		while(length--) hex += chars[(Math.random() * 16) | 0];
		return hex;
	}

	getInitialsColor(firstLetter: string, secondLetter: string) {
		var initialVal = 1;
		if (firstLetter.charCodeAt(0) >= secondLetter.charCodeAt(0)) {
			initialVal = firstLetter.charCodeAt(0) / secondLetter.charCodeAt(0);
		} else {
			initialVal = secondLetter.charCodeAt(0) / firstLetter.charCodeAt(0);
		}
		var color = Math.floor(0x1000000 * initialVal).toString(16);
		return '#' + ('000000' + color).slice(-6);
	}

	getqAvatarColor(avatarText: string) {
		var hex = 0;
		for(var i = 0; i < avatarText.length; i++)
		{
			hex += avatarText.charCodeAt(i) * Math.pow(2, 18 - i);
		}
		var hexVal = '000000' + Math.floor(hex).toString(16);
		hexVal = '#' + hexVal.slice(-6);

		return hexVal;
	}

	// Round prices for a defined number of decimal places.
	roundPrices(value, decimals) {
        return Number(Math.round((value + Number.EPSILON) * Math.pow(10, decimals)) / Math.pow(10, decimals));
    }

	/**
	 * Showing Confirmation Swal-Dialog before Entity Removing
	 *
	 * @param title: string
	 * @param description: string
	 * @param waitDesciption: string
	 */
	deleteElement(title: string = '', description: string = '', waitDesciption: string = '') {
		return Swal.fire(
			{
				title,
				text: description,
				icon: 'question',
				showCloseButton: true,
				showCancelButton: true,
				confirmButtonText: 'Löschen',
				cancelButtonText: 'Abbruch',
			});
	}

		/**
	 * Showing (Mat-Snackbar) Notification
	 *
	 * @param message: string
	 * @param type: MessageType
	 * @param duration: number
	 * @param showCloseButton: boolean
	 * @param showUndoButton: boolean
	 * @param undoButtonDuration: number
	 * @param verticalPosition: 'top' | 'bottom' = 'top'
	 */
	showActionNotification(
		_message: string,
		_type: MessageType = MessageType.Create,
		_duration: number = 10000,
		_showCloseButton: boolean = true,
		_showUndoButton: boolean = true,
		_undoButtonDuration: number = 3000,
		_verticalPosition: 'top' | 'bottom' = 'bottom'
	) {
		const _data = {
			message: _message,
			snackBar: this.snackBar,
			showCloseButton: _showCloseButton,
			showUndoButton: _showUndoButton,
			undoButtonDuration: _undoButtonDuration,
			verticalPosition: _verticalPosition,
			type: _type,
			action: 'Undo',
		};


		return this.snackBar.open(_message,"Action",{
			duration: _duration,
			data: _data,
			verticalPosition: _verticalPosition,
			// panelClass: ['snackbar-green']
		});
		// return this.snackBar.openFromComponent(ActionNotificationComponent, {
		// 	duration: _duration,
		// 	data: _data,
		// 	verticalPosition: _verticalPosition,
		// 	// panelClass: ['snackbar-green']
		// });
	}

	/** QWERT **
	 * Showing Confirmation (Mat-Dialog) before Entity Removing
	 *
	 * @param title: string
	 * @param description: string
	 * @param waitDesciption: string
	 */
	errorMessage(title: string = '', message: string = '', errorCode: string = '') {
		return Swal.fire(
			{
				title,
				text: message,
				icon: 'error',
				showCloseButton: true,

				confirmButtonText: 'Ok',
			});
	}
	
	/**
	 * Open Dialog (Mat-Dialog) for common tasks.
	 *
	 * @param title: string
	 * @param description: string
	 * @param icon: string
	 */
		qwertDialog(title: string = '', description: string = '', _icon: SweetAlertIcon = 'question',
		_showCloseButton: boolean = true, _showCancelButton: boolean = true, _confirmButtonText: string = "OK", _cancelButtonText: string = "Cancel") {

		return Swal.fire(
		{
			title,
			text: description,
			icon: _icon,
			showCloseButton: _showCloseButton,
			showCancelButton: _showCancelButton,
			confirmButtonText: _confirmButtonText,
			cancelButtonText: _cancelButtonText,
		});
	}

}